module.exports = __webpack_public_path__ + "static/selected-language-screen@3x-39a6e70a2e13fad8f82108322f0c8fb3.png";